<template>
    <div id="searchWrap">
      <Input
        v-model="keyword"
        placeholder="输入关键词搜索地址"
        @on-keyup="searchResult"
        @on-search="searchResult"
        search
        :enter-button="btn ? '搜索' : false"
      />
      <p v-show="searching" id="searching">内容搜索中</p>
      <div class="searchUl123" v-show="openSelect">
        <ul>
          <li
            v-for="(item, index) in carArr"
            :key="index"
            @click="clickSearch(item)"
            class="clearfloat"
          >
            <span style="color: #000">{{ item.carNo }}</span>
            
          </li>
        </ul>
      </div>
    </div>
  </template>
  <script>
  export default {
    props: ["btn"],
    data() {
      return {
        //搜索
        openSelect: false,
        keyword: "",
        searching: false,
        carArr: [],
        userGroupArr: [],
        deviceArr: [],
        simArr: [],
      };
    },
    methods: {
      searchResult(v) {
        this.searching = true;
        if (this.keyword.length < 2) {
          this.carArr = [];
          this.searching = false;
          this.openSelect = false;
          return;
        }
        let params = {
          keyword: this.keyword,
          returnCoord: 2,
        };
        this.axios({
          method: "post",
          url: this.axios.lbs + "/locate/getLocate",
          data: params,
        }).then((res) => {
          this.searching = false;
          var data = res.data.data;
          this.carArr = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].active) {
              this.carArr.push(data[i])
            }      
          }
          this.openSelect = true;
        });
      },
      clickSearch(row) {
        this.$emit("adds", row);
        this.keyword = row.carNo;
        this.openSelect = false;
        this.carArr = [];
      },
    },
    watch: {
      keyword(v) {
        if (v.length == 0) {
          this.$emit("clearAdd");
        }
      },
    },
  };
  </script>
  <style lang="">
  #searchWrap {
    position: relative;
    width: 300px;
  }
  #searching {
    position: absolute;
    left: 0;
    top: 30px;
    z-index: 20;
    background: #fff;
    width: 100%;
    border: solid 1px #ccc;
    padding: 10px;
    line-height: 2;
  }
  .searchUl123 {
    position: absolute;
    left: 0;
    top: 30px;
    z-index: 20;
    background: #fff;
    width: 100%;
    max-height: 300px;
    border: solid 1px #ccc;
    overflow: auto;
    padding: 10px;
    line-height: 2;
  }
  .searchUl123 li:hover {
    cursor: pointer;
    color: red;
  }
  </style>


// WEBPACK FOOTER //
// src/components/rule/searchLocateByCar.vue